/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansBold } from 'components/Text';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import { FontWeight } from 'components/Text';

const propTypes = {
    canShow: PropTypes.bool,
    pink:PropTypes.string
  };

const Dialog = styled.div`
position: fixed; 
z-index: 99999999; 
padding-top: ${({paddingTop}) => '10vh' || '30vh'}
left: 0;
top: 0;
width: 100%; 
height: 100%; 
overflow: auto; 
background-color: rgba(255,255,255,0.4);

${({ canShow }) =>
canShow
  ? css`
      display: block;
      `
  : `display: none;`
}
`;

const DialogBody = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 25px;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  width: ${({width}) => width || '400px'}
  height: auto;
  min-height: 100px;
  border-radius: 4px;
`;

const DialogIcon = styled.div`
    height: 30px;
    display: block;
    width: 100%;
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
    }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;

const DialogText = styled.p`
    display: block;
    color: ${Colors.GRAY[6]};
    font-weight: ${FiraSansBold};
    font-family: 'Fira Sans', sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    float: left;
    margin: 0px;
    margin-left: 8px;
    margin-top: 1px;
`;

export {Dialog, DialogBody, DialogIcon, DialogText};



